import { TextField } from "@mui/material";
import type { Ref } from "react";
import type { FieldError } from "react-hook-form";

interface TextFieldDEProps {
  value: number | null;
  label?: string;
  disabled?: boolean;
  inputRef?: Ref<any | undefined>;
  fieldError?: FieldError | undefined;
  onChange?: (value: number) => void;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const NumberTextFieldDE = ({
  value,
  label,
  disabled = false,
  inputRef,
  fieldError,
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
}: TextFieldDEProps) => {
  return (
    <TextField
      fullWidth
      disabled={disabled}
      label={label}
      variant={"outlined"}
      value={value ?? ""}
      type={"number"}
      inputRef={inputRef}
      error={!!fieldError}
      helperText={fieldError?.message}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onBlur();
        }
      }}
      onFocus={onFocus}
      onChange={(e) => {
        if (
          e.target.value === "" ||
          /^(0|[1-9]\d*)(\.\d*)?$/.test(e.target.value)
        )
          onChange(Number(e.target.value));
      }}
      onBlur={() => {
        onBlur();
      }}
      style={{
        minWidth: "50px",
      }}
    />
  );
};
